import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { BANK_PREFERENCE } from '../../config/const.config';

const BankPreference = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  disabled,
  sx,
  error,
}) => (
  <FormControl fullWidth error={error !== ''} variant="filled">
    <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id={id}
      name={name}
      value={defaultValue}
      label={label}
      onChange={onChange}
      disabled={disabled}
      sx={sx}
    >
      {Object.keys(BANK_PREFERENCE).map((b) => (
        <MenuItem key={`${id}-b-${b}`} value={b}>
          {BANK_PREFERENCE[b]}
        </MenuItem>
      ))}
    </Select>
    {error !== '' && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

BankPreference.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
BankPreference.defaultProps = {
  disabled: false,
  sx: {},
  error: '',
};

export default BankPreference;
